import PropTypes from "prop-types";
import getImagePath from "shared/util/getImagePath";

const HUB_MEDIA_URL = `${getImagePath()}/media/img/hub`;

export const CAREERS_MEDIA_URL = `${HUB_MEDIA_URL}/career`;

export const SLIDESHOW_DATA = [
	{
		id: 0,
		url: `${HUB_MEDIA_URL}/slideshow/slide_backend.jpg`,
		alt: "The OkCupid Backend Team",
	},
	{
		id: 1,
		url: `${HUB_MEDIA_URL}/slideshow/slide_frontend.jpg`,
		alt: "The OkCupid Frontend Team",
	},
	{
		id: 2,
		url: `${HUB_MEDIA_URL}/slideshow/slide_marketing.jpg`,
		alt: "The OkCupid Marketing Team",
	},
	{
		id: 3,
		url: `${HUB_MEDIA_URL}/slideshow/slide_android.jpg`,
		alt: "The OkCupid Android Team",
	},
	{
		id: 4,
		url: `${HUB_MEDIA_URL}/slideshow/slide_datascience.jpg`,
		alt: "The OkCupid Data Science Team",
	},
	{
		id: 5,
		url: `${HUB_MEDIA_URL}/slideshow/slide_ios.jpg`,
		alt: "The OkCupid iOS Team",
	},
];

export const JOP_POSTINGS_API_URL = "https://api.lever.co/v0/postings/matchgroup?department=okcupid&mode=json";

// https://github.com/lever/postings-api/blob/master/README.md#get-a-list-of-job-postings
export const JOB_SHAPE = PropTypes.shape({
	additional: PropTypes.string,
	additionalPlain: PropTypes.string,
	applyUrl: PropTypes.string,
	categories: PropTypes.shape({
		commitment: PropTypes.string,
		department: PropTypes.string,
		location: PropTypes.string,
		team: PropTypes.string,
	}),
	createdAt: PropTypes.number,
	description: PropTypes.string,
	descriptionPlain: PropTypes.string,
	hostedUrl: PropTypes.string,
	id: PropTypes.string,
	lists: PropTypes.array,
	text: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/apps/careers/util/constants.js